import type { MantineSize } from '@mantine/core';
import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const useIsBelowMantineBreakpoint = (breakpoint: MantineSize): boolean => {
  const theme = useMantineTheme();
  return !!useMediaQuery(`(max-width: ${theme.breakpoints[breakpoint]})`);
};

export default useIsBelowMantineBreakpoint;
